// Public UI adapted from Klargo-Reference/components/vehicles/VehicleTypeVisual.tsx.
import { cn } from '../../lib/utils.jsx';
import carArtwork from '../../assets/vehicles/car.png';
import motorcycleArtwork from '../../assets/vehicles/motorcycle.png';
import mopedArtwork from '../../assets/vehicles/moped.png';
import camperArtwork from '../../assets/vehicles/camper.png';
import lightTruckArtwork from '../../assets/vehicles/lighttruck.png';
const artwork = {
    car: carArtwork,
    motorcycle: motorcycleArtwork,
    moped: mopedArtwork,
    camper: camperArtwork,
    lightTruck: lightTruckArtwork,
};
const VehicleTypeVisual = ({ kind, className }) => (<img src={artwork[kind]} alt="" aria-hidden="true" loading="lazy" className={cn('block h-auto w-full object-contain', className)}/>);
export default VehicleTypeVisual;
